"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _animator = _interopRequireDefault(require("../animator"));
var _logo = _interopRequireDefault(require("../logo"));
var _hamburgerButton = _interopRequireDefault(require("../hamburger-button"));
var _closeButton = _interopRequireDefault(require("../close-button"));
var _theme = require("../theme");
require("./navbar.css");
var _excluded = ["tagName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var NavLink = function NavLink(_ref) {
  var TagName = _ref.tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    className: "py2 m1 block text-noUnderline text-upper text-bold text-xxs"
  }, otherProps));
};
NavLink.defaultProps = {
  tagName: 'a'
};

/**
 * A navbar designed to work within the header crate which includes a logo, navigation links,
 * and a 'hamburger' menu button. Given a prop for viewport width, this component will calculate
 * which nav items fit in the viewport and hide any that would be truncated.
 *
 * The navbar is expected to be visually positioned within the `HeaderCrate` and has predefined
 * styles to facilitate that positioning.
 */
var NavBar = /*#__PURE__*/function (_Component) {
  function NavBar(props) {
    var _this;
    _classCallCheck(this, NavBar);
    _this = _callSuper(this, NavBar, [props]);
    _this.state = {
      lastVisibleItem: props.items.length - 1
    };
    return _this;
  }
  _inherits(NavBar, _Component);
  return _createClass(NavBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkVisibleItems();
      // eslint-disable-next-line no-console
      console.warn('CXE Pattern Library: NavBar is deprecated. Please update your site to use GlobalNav.');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.checkVisibleItems(prevProps);
    }
  }, {
    key: "checkVisibleItems",
    value: function checkVisibleItems() {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props = this.props,
        viewportWidth = _this$props.viewportWidth,
        items = _this$props.items;
      if (prevProps.viewportWidth === viewportWidth && prevProps.items === items) {
        return;
      }

      // Reset any scrollLeft set by focusing on hidden items. (We hide them as soon
      // as JS kicks in, so this is just a precaution in case users tab through them
      // before that.)
      this.$navContainer.scrollLeft = 0;
      var navContainerRight = this.$navContainer.getBoundingClientRect().right;
      // Assume that no items are visible by default (this is theoretically
      // possible on very small screens, or with very long words).
      var lastVisibleItem = -1;

      // Loop through items backwards, checking the right position. Stop when we hit
      // the first one which fits in the container.
      for (var i = items.length - 1; i >= 0; i--) {
        var itemRight = this["$navItem".concat(i)].getBoundingClientRect().right;
        if (itemRight <= navContainerRight) {
          lastVisibleItem = i;
          break;
        }
      }
      if (lastVisibleItem !== this.state.lastVisibleItem) {
        this.setState({
          lastVisibleItem: lastVisibleItem
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        headerProps = _this$props2.headerProps,
        items = _this$props2.items,
        logoProps = _this$props2.logoProps,
        messages = _this$props2.messages,
        navOverlayActive = _this$props2.navOverlayActive,
        hideNavOverlay = _this$props2.hideNavOverlay,
        showNavOverlay = _this$props2.showNavOverlay;
      return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
        var themeDark = theme === _theme.themes.dark;
        var buttonColorClass = themeDark ? 'color-textWhiteSoft' : 'color-textBlackSoft';
        return /*#__PURE__*/_react["default"].createElement("header", _extends({
          className: (0, _classnames["default"])('sb-navbar sb-global-gutters width-100 flex items-center', {
            fixed: navOverlayActive,
            'bg-white': !themeDark,
            'bg-houseGreen color-textWhite': themeDark
          })
        }, headerProps), /*#__PURE__*/_react["default"].createElement(_logo["default"], _extends({
          className: "sb-navbar-siren",
          onClick: navOverlayActive ? hideNavOverlay : undefined,
          size: "100%"
        }, logoProps)), /*#__PURE__*/_react["default"].createElement("nav", {
          className: "flex flex-auto items-center justify-between pl3 md-pl4"
        }, /*#__PURE__*/_react["default"].createElement("ul", {
          className: (0, _classnames["default"])('whiteSpace-truncate flex-auto sb-navbar-list', {
            'sb-navbar-list__hidden': navOverlayActive
          }),
          ref: function ref(el) {
            return _this2.$navContainer = el;
          }
        }, items.map(function (item, i) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            className: (0, _classnames["default"])('sb-navbar-item', {
              'pl2 md-pl3': i > 0,
              hidden: i > _this2.state.lastVisibleItem
            }),
            key: i,
            ref: function ref(el) {
              return _this2["$navItem".concat(i)] = el;
            }
          }, /*#__PURE__*/_react["default"].createElement(NavLink, item));
        })), /*#__PURE__*/_react["default"].createElement(_animator["default"], {
          className: "sb-navbar-iconContainer"
        }, navOverlayActive ? /*#__PURE__*/_react["default"].createElement(_closeButton["default"], {
          ariaLabel: messages.menuCloseLabel,
          className: "absolute mr3 sb-navbar-icon ".concat(buttonColorClass),
          key: "close-icon",
          onClick: hideNavOverlay
        }) : /*#__PURE__*/_react["default"].createElement(_hamburgerButton["default"], {
          animateToCloseOnClick: false,
          className: "absolute mr3 sb-navbar-icon ".concat(buttonColorClass),
          key: "hamburger-icon",
          menuButtonAriaLabel: messages.menuLabel,
          onClick: showNavOverlay
        }))));
      });
    }
  }]);
}(_react.Component);
NavBar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Additional props to be spread on the header HTMLElement.
   */
  headerProps: _propTypes["default"].object,
  items: _propTypes["default"].array,
  logoProps: _propTypes["default"].object,
  messages: _propTypes["default"].shape({
    menuCloseLabel: _propTypes["default"].string,
    menuLabel: _propTypes["default"].string
  }),
  navOverlayActive: _propTypes["default"].bool,
  hideNavOverlay: _propTypes["default"].func,
  showNavOverlay: _propTypes["default"].func,
  viewportWidth: _propTypes["default"].number
} : {};
NavBar.displayName = 'Navbar';
var _default = exports["default"] = NavBar;